module.exports = __webpack_public_path__ + "static/homepage-background-new-b1d3a3e6f6af98ee80dbf9ce7cfa8117.jpg";